import {
  createValidation,
  validatorRequired,
  validatorDateGreaterThen,
  validatorDateGreaterThenOrInitial,
} from '../../utils/formValidators';

import { activityPeriodFormFields } from '../../constants/formsAddEquipment';

export default createValidation([
  {
    name: activityPeriodFormFields.START_DATE,
    validators: (field, form) =>
      form.get(activityPeriodFormFields.ELIGIBLE_FOR_SUBSIDY)
        ? validatorRequired()(field)
        : undefined,
  },
  {
    name: activityPeriodFormFields.START_DATE,
    validators: (value, values, props, name) =>
      validatorDateGreaterThenOrInitial()(value, values, props, name),
  },
  {
    name: activityPeriodFormFields.END_DATE,
    validators: (field, form) => {
      const startDate = form.get(activityPeriodFormFields.START_DATE);
      return startDate ? validatorDateGreaterThen(startDate)(field) : undefined;
    },
  },
  {
    name: activityPeriodFormFields.DECISION_DATE,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: activityPeriodFormFields.ELIGIBLE_FOR_SUBSIDY,
    validators: [(field) => validatorRequired()(field)],
  },
]);
